import Accordion from 'accordion-js';
new Accordion('.accordion-container');
